var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var eregStaffPlaceholderAppointmentEditTemplate = require('./eregStaffPlaceholderAppointmentEditTemplate.hbs');
var EregPlaceholderAppointmentFormView = require('./EregPlaceholderAppointmentFormView');
var UseModalBehavior = require('./../../widget/modal/UseModalBehavior');
var ModalDialogWidget = require('./../../widget/modal/ModalDialogWidget');
var EregStaffSelectWorkflowReviewView = require('../staff-select-workflow-review-modal/EregStaffSelectWorkflowReviewView');
var EregAppointmentSelectWorkflowFormView = require('../select-workflow-nodes/EregAppointmentSelectWorkflowFormView');
var EregAppointmentSelectWorkflowFormModel = require('../select-workflow-nodes/EregAppointmentSelectWorkflowFormModel');
var AppointmentModel = require('./../../appointment/AppointmentModel');
var sessionStorageService = require('./../../storage/sessionStorageService');
var staffLogoutWithRedirectToEreg = require('./../../authentication/logoutUtils').staffLogoutWithRedirectToEreg;
var AppointmentNavigationConfirmBehavior = require('../navigation-confirm/AppointmentNavigationConfirmBehavior');

/**
 * Perspective to display the E-reg staff new appointment edit/create page.
 *
 * @class EregStaffPlaceholderAppointmentEditPerspective
 * @constructor
 * @param options {Object} the options for creating this view.
 *   @param options.patientVecnaId {String} Vecna id of the patient that the appointment is for.
 * @uses appointmentNavigationConfirmMixin
 */
module.exports = TorsoView.extend({
  className: 'page-content page-content--ereg-staff-placeholder-appointment-edit brec-main',
  tagName: 'main',
  template: eregStaffPlaceholderAppointmentEditTemplate,
  moduleNamespace: 'eregStaffPlaceholderAppointmentEdit',

  behaviors: {
    appointmentNavigationConfirm: {
      behavior: AppointmentNavigationConfirmBehavior
    },
    useModalBehavior: {
      behavior: UseModalBehavior
    }
  },

  events: {
    'click .button--staff-placeholder-appointment-edit': '_openReviewModal'
  },

  /**
   * @method initialize
   * @param options {Object} the options for creating this view.
   *   @param options.patientVecnaId {String} Vecna id of the patient that the appointment is for.
   * @override
   */
  initialize: function(options) {
    options = options || {};
    this._patientVecnaId = options.patientVecnaId;

    this._appointmentModel = new AppointmentModel({patientVecnaId : this._patientVecnaId});
    this._eregPlaceholderAppointmentFormView = new EregPlaceholderAppointmentFormView({patientVecnaId: this._patientVecnaId,
                                                                                       appointmentModel: this._appointmentModel});

    this._eregAppointmentSelectWorkflowFormView = new EregAppointmentSelectWorkflowFormView({
      model: new EregAppointmentSelectWorkflowFormModel()
    });

    this.listenTo(this._appointmentModel, 'change:externalAppointment', this._setAppointmentTypeExternalId);

    this.set({
      asideHeaderMessageKey: 'ereg.appointments.aside.header',
      asideContentMessageKey: 'ereg.staffPlaceholderAppointmentEdit.aside'
    });

    this.set('navView', 'eregStaff');
  },

  /**
   * @method prepare
   * @override
   */
  prepare: function() {
    return {
      patientVecnaId: this._patientVecnaId
    };
  },

  /**
   * @method attachTrackedViews
   * @override
   */
  attachTrackedViews: function() {
    this.attachView('select-visit-type', this._eregPlaceholderAppointmentFormView);
    this.attachView('select-workflow', this._eregAppointmentSelectWorkflowFormView);
  },

  /**
   * @method _setAppointmentTypeExternalId
   * Set the appointment model to the appointment select workflow form view
   */
  _setAppointmentTypeExternalId: function() {
    this._eregAppointmentSelectWorkflowFormView.set('appointmentTypeExternalId', this._appointmentModel.get('externalAppointment').type);
  },

  /**
   * Sets the review modal to render and provides it with the data it needs from the form views.
   * @method _openReviewModal
   * @private
   */
  _openReviewModal: function() {
    var errors = this._eregPlaceholderAppointmentFormView.validate();
    if (errors) {
      return;
    }
    this.showModal(new ModalDialogWidget({
      dataViewName: 'review appointment',
      className: 'brec-dialog brec-dialog--regular',
      headerKey: 'eregStaffSelectWorkflow.reviewModal.header',
      closeTitleKey: 'eregStaffSelectWorkflow.reviewModal.close',
      yesKey: 'eregStaffSelectWorkflow.reviewModal.allSetBtn',
      noKey: 'eregStaffPlaceholderAppointment.pleaseReviewModal.editBtn',
      stackButtons: true,
      trackedView: new EregStaffSelectWorkflowReviewView({
        patientVecnaId : this._patientVecnaId,
        appointmentModel: this._appointmentModel,
        workflowFormModel: this._eregAppointmentSelectWorkflowFormView.model
      })
    }), _.bind(this._savePlaceholderAppointment, this));
  },

  /**
   * Saves the placeholder appointment to the backend.
   * @method _savePlaceholderAppointment
   * @private
   */
  _savePlaceholderAppointment: function() {
    var workflowFormModel = this._eregAppointmentSelectWorkflowFormView.model,
        disabledSteps = workflowFormModel.getDisabledWorkflowSteps(),
        patientVecnaId = this._patientVecnaId;

    this._appointmentModel.createAsPlaceholder().then(function(newAppointment) {
      var eregWorkflowConfig = {
        patientVecnaId: patientVecnaId,
        appointmentExtId: newAppointment.externalId,
        disabledSteps: disabledSteps
      };
      sessionStorageService.setItem(sessionStorageService.SESSION_STORAGE_KEYS.eregWorkflowConfig, eregWorkflowConfig);
    })
    .then(staffLogoutWithRedirectToEreg);
  }
});
